import CrownForm from "./CrownForm.ts";
import Tracking from "./Tracking.ts";

!(function e(t, o, n) {
  function i(a, s) {
    if (!o[a]) {
      if (!t[a]) {
        var l = "function" == typeof require && require;
        if (!s && l) return l(a, !0);
        if (r) return r(a, !0);
        var u = new Error("Cannot find module '" + a + "'");
        throw ((u.code = "MODULE_NOT_FOUND"), u);
      }
      var c = (o[a] = { exports: {} });
      t[a][0].call(
        c.exports,
        function(e) {
          var o = t[a][1][e];
          return i(o || e);
        },
        c,
        c.exports,
        e,
        t,
        o,
        n,
      );
    }
    return o[a].exports;
  }

  for (
    var r = "function" == typeof require && require, a = 0;
    a < n.length;
    a++
  )
    i(n[a]);
  return i;
})(
  {
    1: [
      function(e, t) {
        t.exports = function(e, t, o) {
          function n() {
            var u = Date.now() - s;
            u < t && u >= 0
              ? (i = setTimeout(n, t - u))
              : ((i = null), o || ((l = e.apply(a, r)), (a = r = null)));
          }

          var i, r, a, s, l;
          null == t && (t = 100);
          var u = function() {
            (a = this), (r = arguments), (s = Date.now());
            var u = o && !i;
            return (
              i || (i = setTimeout(n, t)),
              u && ((l = e.apply(a, r)), (a = r = null)),
                l
            );
          };
          return (
            (u.clear = function() {
              i && (clearTimeout(i), (i = null));
            }),
              (u.flush = function() {
                i &&
                ((l = e.apply(a, r)),
                  (a = r = null),
                  clearTimeout(i),
                  (i = null));
              }),
              u
          );
        };
      },
      {},
    ],
    2: [
      function(e, t) {
        !(function(e, o) {
          var n = (function(e, t) {
            "use strict";
            if (t.getElementsByClassName) {
              var o,
                n = t.documentElement,
                i = e.Date,
                r = e.HTMLPictureElement,
                a = "addEventListener",
                s = "getAttribute",
                l = e[a],
                u = e.setTimeout,
                c = e.requestAnimationFrame || u,
                d = e.requestIdleCallback,
                f = /^picture$/i,
                p = ["load", "error", "lazyincluded", "_lazyloaded"],
                m = {},
                v = Array.prototype.forEach,
                h = function(e, t) {
                  return (
                    m[t] || (m[t] = new RegExp("(\\s|^)" + t + "(\\s|$)")),
                    m[t].test(e[s]("class") || "") && m[t]
                  );
                },
                y = function(e, t) {
                  h(e, t) ||
                  e.setAttribute(
                    "class",
                    (e[s]("class") || "").trim() + " " + t,
                  );
                },
                b = function(e, t) {
                  var o;
                  (o = h(e, t)) &&
                  e.setAttribute(
                    "class",
                    (e[s]("class") || "").replace(o, " "),
                  );
                },
                g = function(e, t, o) {
                  var n = o ? a : "removeEventListener";
                  o && g(e, t),
                    p.forEach(function(o) {
                      e[n](o, t);
                    });
                },
                A = function(e, o, n, i, r) {
                  var a = t.createEvent("CustomEvent");
                  return (
                    a.initCustomEvent(o, !i, !r, n || {}), e.dispatchEvent(a), a
                  );
                },
                _ = function(t, n) {
                  var i;
                  !r && (i = e.picturefill || o.pf)
                    ? i({ reevaluate: !0, elements: [t] })
                    : n && n.src && (t.src = n.src);
                },
                C = function(e, t) {
                  return (getComputedStyle(e, null) || {})[t];
                },
                $ = function(e, t, n) {
                  for (
                    n = n || e.offsetWidth;
                    n < o.minSize && t && !e._lazysizesWidth;
                  )
                    (n = t.offsetWidth), (t = t.parentNode);
                  return n;
                },
                w = (function() {
                  var e,
                    o,
                    n = [],
                    i = [],
                    r = n,
                    a = function() {
                      var t = r;
                      for (r = n.length ? i : n, e = !0, o = !1; t.length;)
                        t.shift()();
                      e = !1;
                    },
                    s = function(n, i) {
                      e && !i
                        ? n.apply(this, arguments)
                        : (r.push(n), o || ((o = !0), (t.hidden ? u : c)(a)));
                    };
                  return (s._lsFlush = a), s;
                })(),
                z = function(e, t) {
                  return t
                    ? function() {
                      w(e);
                    }
                    : function() {
                      var t = this,
                        o = arguments;
                      w(function() {
                        e.apply(t, o);
                      });
                    };
                },
                S = function(e) {
                  var t,
                    o = 0,
                    n = 666,
                    r = function() {
                      (t = !1), (o = i.now()), e();
                    },
                    a = d
                      ? function() {
                        d(r, { timeout: n }), 666 !== n && (n = 666);
                      }
                      : z(function() {
                        u(r);
                      }, !0);
                  return function(e) {
                    var r;
                    (e = !0 === e) && (n = 44),
                    t ||
                    ((t = !0),
                    (r = 125 - (i.now() - o)) < 0 && (r = 0),
                      e || (r < 9 && d) ? a() : u(a, r));
                  };
                },
                q = function(e) {
                  var t,
                    o,
                    n = function() {
                      (t = null), e();
                    },
                    r = function() {
                      var e = i.now() - o;
                      e < 99 ? u(r, 99 - e) : (d || n)(n);
                    };
                  return function() {
                    (o = i.now()), t || (t = u(r, 99));
                  };
                },
                k = (function() {
                  var r,
                    c,
                    d,
                    p,
                    m,
                    $,
                    k,
                    T,
                    E,
                    L,
                    P,
                    N,
                    M,
                    j,
                    Z,
                    O = /^img$/i,
                    R = /^iframe$/i,
                    B = "onscroll" in e && !/glebot/.test(navigator.userAgent),
                    F = 0,
                    D = 0,
                    U = -1,
                    W = function(e) {
                      D--,
                      e && e.target && g(e.target, W),
                      (!e || D < 0 || !e.target) && (D = 0);
                    },
                    I = function(e, o) {
                      var i,
                        r = e,
                        a =
                          "hidden" == C(t.body, "visibility") ||
                          "hidden" != C(e, "visibility");
                      for (
                        E -= o, N += o, L -= o, P += o;
                        a && (r = r.offsetParent) && r != t.body && r != n;
                      )
                        (a = (C(r, "opacity") || 1) > 0) &&
                        "visible" != C(r, "overflow") &&
                        ((i = r.getBoundingClientRect()),
                          (a =
                            P > i.left &&
                            L < i.right &&
                            N > i.top - 1 &&
                            E < i.bottom + 1));
                      return a;
                    },
                    H = function() {
                      var e, i, a, l, u, f, p, v, h;
                      if ((m = o.loadMode) && D < 8 && (e = r.length)) {
                        (i = 0),
                          U++,
                        null == j &&
                        ("expand" in o ||
                        (o.expand =
                          n.clientHeight > 500 && n.clientWidth > 500
                            ? 500
                            : 370),
                          (M = o.expand),
                          (j = M * o.expFactor)),
                          F < j && D < 1 && U > 2 && m > 2 && !t.hidden
                            ? ((F = j), (U = 0))
                            : (F = m > 1 && U > 1 && D < 6 ? M : 0);
                        for (; i < e; i++)
                          if (r[i] && !r[i]._lazyRace)
                            if (B)
                              if (
                                (((v = r[i][s]("data-expand")) &&
                                  (f = 1 * v)) ||
                                (f = F),
                                h !== f &&
                                ((k = innerWidth + f * Z),
                                  (T = innerHeight + f),
                                  (p = -1 * f),
                                  (h = f)),
                                  (a = r[i].getBoundingClientRect()),
                                (N = a.bottom) >= p &&
                                (E = a.top) <= T &&
                                (P = a.right) >= p * Z &&
                                (L = a.left) <= k &&
                                (N || P || L || E) &&
                                ((d && D < 3 && !v && (m < 3 || U < 4)) ||
                                  I(r[i], f)))
                              ) {
                                if ((Y(r[i]), (u = !0), D > 9)) break;
                              } else
                                !u &&
                                d &&
                                !l &&
                                D < 4 &&
                                U < 4 &&
                                m > 2 &&
                                (c[0] || o.preloadAfterLoad) &&
                                (c[0] ||
                                  (!v &&
                                    (N ||
                                      P ||
                                      L ||
                                      E ||
                                      "auto" != r[i][s](o.sizesAttr)))) &&
                                (l = c[0] || r[i]);
                            else Y(r[i]);
                        l && !u && Y(l);
                      }
                    },
                    K = S(H),
                    G = function(e) {
                      y(e.target, o.loadedClass),
                        b(e.target, o.loadingClass),
                        g(e.target, J);
                    },
                    V = z(G),
                    J = function(e) {
                      V({ target: e.target });
                    },
                    X = function(e) {
                      var t,
                        n,
                        i = e[s](o.srcsetAttr);
                      (t =
                        o.customMedia[e[s]("data-media") || e[s]("media")]) &&
                      e.setAttribute("media", t),
                      i && e.setAttribute("srcset", i),
                      t &&
                      ((n = e.parentNode).insertBefore(e.cloneNode(), e),
                        n.removeChild(e));
                    },
                    Q = z(function(e, t, n, i, r) {
                      var a, l, c, d, m, h;
                      (m = A(e, "lazybeforeunveil", t)).defaultPrevented ||
                      (i &&
                      (n
                        ? y(e, o.autosizesClass)
                        : e.setAttribute("sizes", i)),
                        (l = e[s](o.srcsetAttr)),
                        (a = e[s](o.srcAttr)),
                      r &&
                      ((c = e.parentNode),
                        (d = c && f.test(c.nodeName || ""))),
                        (h = t.firesLoad || ("src" in e && (l || a || d))),
                        (m = { target: e }),
                      h &&
                      (g(e, W, !0),
                        clearTimeout(p),
                        (p = u(W, 2500)),
                        y(e, o.loadingClass),
                        g(e, J, !0)),
                      d && v.call(c.getElementsByTagName("source"), X),
                        l
                          ? e.setAttribute("srcset", l)
                          : a &&
                          !d &&
                          (R.test(e.nodeName)
                            ? (function(e, t) {
                              try {
                                e.contentWindow.location.replace(t);
                              } catch (o) {
                                e.src = t;
                              }
                            })(e, a)
                            : (e.src = a)),
                      (l || d) && _(e, { src: a })),
                      e._lazyRace && delete e._lazyRace,
                        b(e, o.lazyClass),
                        w(function() {
                          (!h || (e.complete && e.naturalWidth > 1)) &&
                          (h ? W(m) : D--, G(m));
                        }, !0);
                    }),
                    Y = function(e) {
                      var t,
                        n = O.test(e.nodeName),
                        i = n && (e[s](o.sizesAttr) || e[s]("sizes")),
                        r = "auto" == i;
                      ((!r && d) ||
                        !n ||
                        (!e.src && !e.srcset) ||
                        e.complete ||
                        h(e, o.errorClass)) &&
                      ((t = A(e, "lazyunveilread").detail),
                      r && x.updateElem(e, !0, e.offsetWidth),
                        (e._lazyRace = !0),
                        D++,
                        Q(e, t, r, i, n));
                    },
                    ee = function() {
                      if (!d) {
                        if (i.now() - $ < 999) return void u(ee, 999);
                        var e = q(function() {
                          (o.loadMode = 3), K();
                        });
                        (d = !0),
                          (o.loadMode = 3),
                          K(),
                          l(
                            "scroll",
                            function() {
                              3 == o.loadMode && (o.loadMode = 2), e();
                            },
                            !0,
                          );
                      }
                    };
                  return {
                    _: function() {
                      ($ = i.now()),
                        (r = t.getElementsByClassName(o.lazyClass)),
                        (c = t.getElementsByClassName(
                          o.lazyClass + " " + o.preloadClass,
                        )),
                        (Z = o.hFac),
                        l("scroll", K, !0),
                        l("resize", K, !0),
                        e.MutationObserver
                          ? new MutationObserver(K).observe(n, {
                            childList: !0,
                            subtree: !0,
                            attributes: !0,
                          })
                          : (n[a]("DOMNodeInserted", K, !0),
                            n[a]("DOMAttrModified", K, !0),
                            setInterval(K, 999)),
                        l("hashchange", K, !0),
                        [
                          "focus",
                          "mouseover",
                          "click",
                          "load",
                          "transitionend",
                          "animationend",
                          "webkitAnimationEnd",
                        ].forEach(function(e) {
                          t[a](e, K, !0);
                        }),
                        /d$|^c/.test(t.readyState)
                          ? ee()
                          : (l("load", ee),
                            t[a]("DOMContentLoaded", K),
                            u(ee, 2e4)),
                        r.length ? (H(), w._lsFlush()) : K();
                    },
                    checkElems: K,
                    unveil: Y,
                  };
                })(),
                x = (function() {
                  var e,
                    n = z(function(e, t, o, n) {
                      var i, r, a;
                      if (
                        ((e._lazysizesWidth = n),
                          (n += "px"),
                          e.setAttribute("sizes", n),
                          f.test(t.nodeName || ""))
                      )
                        for (
                          i = t.getElementsByTagName("source"),
                            r = 0,
                            a = i.length;
                          r < a;
                          r++
                        )
                          i[r].setAttribute("sizes", n);
                      o.detail.dataAttr || _(e, o.detail);
                    }),
                    i = function(e, t, o) {
                      var i,
                        r = e.parentNode;
                      r &&
                      ((o = $(e, r, o)),
                      (i = A(e, "lazybeforesizes", {
                        width: o,
                        dataAttr: !!t,
                      })).defaultPrevented ||
                      ((o = i.detail.width) &&
                        o !== e._lazysizesWidth &&
                        n(e, r, i, o)));
                    },
                    r = q(function() {
                      var t,
                        o = e.length;
                      if (o) for (t = 0; t < o; t++) i(e[t]);
                    });
                  return {
                    _: function() {
                      (e = t.getElementsByClassName(o.autosizesClass)),
                        l("resize", r);
                    },
                    checkElems: r,
                    updateElem: i,
                  };
                })(),
                T = function() {
                  T.i || ((T.i = !0), x._(), k._());
                };
              return (
                (function() {
                  var t,
                    n = {
                      lazyClass: "lazyload",
                      loadedClass: "lazyloaded",
                      loadingClass: "lazyloading",
                      preloadClass: "lazypreload",
                      errorClass: "lazyerror",
                      autosizesClass: "lazyautosizes",
                      srcAttr: "data-src",
                      srcsetAttr: "data-srcset",
                      sizesAttr: "data-sizes",
                      minSize: 40,
                      customMedia: {},
                      init: !0,
                      expFactor: 1.5,
                      hFac: 0.8,
                      loadMode: 2,
                    };
                  for (t in ((o = e.lazySizesConfig || e.lazysizesConfig || {}),
                    n))
                    t in o || (o[t] = n[t]);
                  (e.lazySizesConfig = o),
                    u(function() {
                      o.init && T();
                    });
                })(),
                  {
                    cfg: o,
                    autoSizer: x,
                    loader: k,
                    init: T,
                    uP: _,
                    aC: y,
                    rC: b,
                    hC: h,
                    fire: A,
                    gW: $,
                    rAF: w,
                  }
              );
            }
          })(e, e.document);
          (e.lazySizes = n),
          "object" == typeof t && t.exports && (t.exports = n);
        })(window);
      },
      {},
    ],
    3: [
      function() {
        "use strict";

        function e() {
          console.log("should be active"),
            $(".c-form-sticky__form").attr("style", ""),
            $(".c-form-sticky__form").removeClass(
              "c-form-sticky__form--mobile",
            ),
            $("body").removeClass("c-form-sticky__footer-padding"),
            i
              .stick_in_parent({ recalc_every: 1 })
              .on("sticky_kit:stick", function() {
                $(window).width() < 1220 && t();
              });
        }

        function t() {
          console.log("should not be active"),
            $("body").addClass("c-form-sticky__footer-padding"),
            i.addClass("c-form-sticky__form--mobile"),
            i.trigger("sticky_kit:detach");
        }

        window.$ = window.jQuery = jQuery;
        var o,
          n = document.querySelectorAll("[data-target-service]");
        for (o = 0; o < n.length; ++o)
          n[o].addEventListener("mouseenter", function() {
            document
              .querySelector("." + this.getAttribute("data-target-service"))
              .classList.add("c-panel-services__single--hover");
          }),
            n[o].addEventListener("mouseleave", function() {
              document
                .querySelector("." + this.getAttribute("data-target-service"))
                .classList.remove("c-panel-services__single--hover");
            });
        var i = $(".c-form-sticky__form.c-form-sticky__form--sticky");
        $(window).width() > 660 && e(),
          $(window).on("resize", function() {
            $(window).width() > 660
              ? e()
              : (t(),
                $(".c-form-sticky__form").addClass(
                  "c-form-sticky__form--mobile",
                ));
          }),
          $(".c-form-sticky__open-button").on("click", function() {
            $(".form-x").fadeToggle(400),
              $(this).toggleClass("c-form-sticky__open-button--active"),
              $(".c-form-wrapper").toggleClass("c-form-wrapper--active"),
              $(".c-form-sticky__open-button").hasClass(
                "c-form-sticky__open-button--active",
              )
                ? ($(".c-form-sticky__form").addClass(
                  "c-form-sticky__form--mobile",
                ),
                  $(".c-form-sticky__form").fadeIn(400))
                : $(".c-form-sticky__form").fadeOut(400, function() {
                  $(".c-form-sticky__form").removeClass(
                    "c-form-sticky__form--mobile",
                  );
                });
          });
      },
      {},
    ],
    4: [
      function(e, t) {
        "use strict";
        var o = (function() {
            function e(e, t) {
              for (var o = 0; o < t.length; o++) {
                var n = t[o];
                (n.enumerable = n.enumerable || !1),
                  (n.configurable = !0),
                "value" in n && (n.writable = !0),
                  Object.defineProperty(e, n.key, n);
              }
            }

            return function(t, o, n) {
              return o && e(t.prototype, o), n && e(t, n), t;
            };
          })(),
          n = e("debounce"),
          i = (function() {
            function e() {
              var t = this;
              (function(e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              })(this, e),
                (this.container = document.querySelector(".o-page-container")),
                (this.menu = document.querySelector(".c-nav-mobile")),
                (this.menuBtn = document.querySelector(".c-header__toggle")),
              this.menu &&
              this.menuBtn.addEventListener(
                "click",
                function() {
                  return t.animateNav();
                },
                !1,
              );
            }

            return (
              o(e, [
                {
                  key: "animateNav",
                  value: function() {
                    n(this.toggleNav(), 200);
                  },
                },
                {
                  key: "toggleNav",
                  value: function() {
                    this.menu.classList.toggle("c-nav-mobile--nav-open"),
                      this.container.classList.toggle(
                        "o-page-container--nav-open",
                      );
                  },
                },
              ]),
                e
            );
          })();
        t.exports = new i();
      },
      { debounce: 1 },
    ],
    5: [
      function() {
        "use strict";
        if (!Modernizr.objectfit) {
          var e = document.querySelectorAll(".c-object-fit");
          [].forEach.call(e, function(e) {
            e.classList.add("c-object-fit--polyfill");
            var t = e.querySelector("img").getAttribute("src");
            e.style.backgroundImage = "url('" + t + "')";
          });
        }
      },
      {},
    ],
    6: [
      function() {
        "use strict";

        function e(e) {
          var t = document.createElement("meta");
          return (
            (t.name = "viewport"),
              t.setAttribute(
                "content",
                "width=device-width, initial-scale=1.0, user-scalable=" + e,
              ),
              o.appendChild(t),
              t
          );
        }

        function t(e) {
          var t = e.target.tagName;
          return -1 !== n.indexOf(t.toLowerCase() + "");
        }

        var o = document.querySelector("head"),
          n = ["input", "select", "textarea"],
          i = function() {
            var t = document.querySelector("meta[name=viewport]");
            t.parentNode.removeChild(t), o.appendChild(e(0));
          },
          r = function() {
            var t = document.querySelector("meta[name=viewport]");
            t.parentNode.removeChild(t), o.appendChild(e(1));
          };
        navigator.userAgent.length &&
        /iPhone|iPad|iPod/i.test(navigator.userAgent) &&
        (document.addEventListener("touchstart", function(e) {
          t(e) && i();
        }),
          document.addEventListener("touchend", function(e) {
            t(e) && setTimeout(r, 500);
          }));
      },
      {},
    ],
    7: [
      function(e) {
        "use strict";
        e("lazysizes");
      },
      { lazysizes: 2 },
    ],
    8: [
      function() {
        "use strict";
        var e =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function(e) {
              return typeof e;
            }
            : function(e) {
              return e &&
              "function" == typeof Symbol &&
              e.constructor === Symbol &&
              e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            };
        !(function(t, o, n) {
          function i(t, o) {
            return (void 0 === t ? "undefined" : e(t)) === o;
          }

          function r() {
            return "function" != typeof o.createElement
              ? o.createElement(arguments[0])
              : A
                ? o.createElementNS.call(
                  o,
                  "http://www.w3.org/2000/svg",
                  arguments[0],
                )
                : o.createElement.apply(o, arguments);
          }

          function a(e) {
            return e
              .replace(/([a-z])-([a-z])/g, function(e, t, o) {
                return t + o.toUpperCase();
              })
              .replace(/^-/, "");
          }

          function s(e, t) {
            return !!~("" + e).indexOf(t);
          }

          function l(e, t) {
            return function() {
              return e.apply(t, arguments);
            };
          }

          function u(e) {
            return e
              .replace(/([A-Z])/g, function(e, t) {
                return "-" + t.toLowerCase();
              })
              .replace(/^ms-/, "-ms-");
          }

          function c(e, t, n, i) {
            var a,
              s,
              l,
              u,
              c = "modernizr",
              d = r("div"),
              f = (function() {
                var e = o.body;
                return e || ((e = r(A ? "svg" : "body")).fake = !0), e;
              })();
            if (parseInt(n, 10))
              for (; n--;)
                ((l = r("div")).id = i ? i[n] : c + (n + 1)), d.appendChild(l);
            return (
              ((a = r("style")).type = "text/css"),
                (a.id = "s" + c),
                (f.fake ? f : d).appendChild(a),
                f.appendChild(d),
                a.styleSheet
                  ? (a.styleSheet.cssText = e)
                  : a.appendChild(o.createTextNode(e)),
                (d.id = c),
              f.fake &&
              ((f.style.background = ""),
                (f.style.overflow = "hidden"),
                (u = g.style.overflow),
                (g.style.overflow = "hidden"),
                g.appendChild(f)),
                (s = t(d, e)),
                f.fake
                  ? (f.parentNode.removeChild(f),
                    (g.style.overflow = u),
                    g.offsetHeight)
                  : d.parentNode.removeChild(d),
                !!s
            );
          }

          function d(e, o) {
            var i = e.length;
            if ("CSS" in t && "supports" in t.CSS) {
              for (; i--;) if (t.CSS.supports(u(e[i]), o)) return !0;
              return !1;
            }
            if ("CSSSupportsRule" in t) {
              for (var r = []; i--;) r.push("(" + u(e[i]) + ":" + o + ")");
              return c(
                "@supports (" +
                (r = r.join(" or ")) +
                ") { #modernizr { position: absolute; } }",
                function(e) {
                  return (
                    "absolute" ==
                    (function(e, o, n) {
                      var i;
                      if ("getComputedStyle" in t) {
                        i = getComputedStyle.call(t, e, o);
                        var r = t.console;
                        null !== i
                          ? n && (i = i.getPropertyValue(n))
                          : r &&
                          r[r.error ? "error" : "log"].call(
                            r,
                            "getComputedStyle returning null, its possible modernizr test results are inaccurate",
                          );
                      } else i = !o && e.currentStyle && e.currentStyle[n];
                      return i;
                    })(e, null, "position")
                  );
                },
              );
            }
            return n;
          }

          function f(e, t, o, l) {
            function u() {
              f && (delete x.style, delete x.modElem);
            }

            if (((l = !i(l, "undefined") && l), !i(o, "undefined"))) {
              var c = d(e, o);
              if (!i(c, "undefined")) return c;
            }
            for (
              var f, p, m, v, h, y = ["modernizr", "tspan", "samp"];
              !x.style && y.length;
            )
              (f = !0), (x.modElem = r(y.shift())), (x.style = x.modElem.style);
            for (m = e.length, p = 0; m > p; p++)
              if (
                ((v = e[p]),
                  (h = x.style[v]),
                s(v, "-") && (v = a(v)),
                x.style[v] !== n)
              ) {
                if (l || i(o, "undefined")) return u(), "pfx" != t || v;
                try {
                  x.style[v] = o;
                } catch (e) {
                }
                if (x.style[v] != h) return u(), "pfx" != t || v;
              }
            return u(), !1;
          }

          function p(e, t, o, n, r) {
            var a = e.charAt(0).toUpperCase() + e.slice(1),
              s = (e + " " + z.join(a + " ") + a).split(" ");
            return i(t, "string") || i(t, "undefined")
              ? f(s, t, n, r)
              : (function(e, t, o) {
                var n;
                for (var r in e)
                  if (e[r] in t)
                    return !1 === o
                      ? e[r]
                      : i((n = t[e[r]]), "function")
                        ? l(n, o || t)
                        : n;
                return !1;
              })((s = (e + " " + q.join(a + " ") + a).split(" ")), t, o);
          }

          function m(e, t, o) {
            return p(e, n, n, t, o);
          }

          var v = [],
            h = [],
            y = {
              _version: "3.6.0",
              _config: {
                classPrefix: "",
                enableClasses: !0,
                enableJSClass: !0,
                usePrefixes: !0,
              },
              _q: [],
              on: function(e, t) {
                var o = this;
                setTimeout(function() {
                  t(o[e]);
                }, 0);
              },
              addTest: function(e, t, o) {
                h.push({ name: e, fn: t, options: o });
              },
              addAsyncTest: function(e) {
                h.push({ name: null, fn: e });
              },
            },
            b = function() {
            };
          (b.prototype = y),
            (b = new b()).addTest("svgfilters", function() {
              var e = !1;
              try {
                e =
                  "SVGFEColorMatrixElement" in t &&
                  2 == SVGFEColorMatrixElement.SVG_FECOLORMATRIX_TYPE_SATURATE;
              } catch (e) {
              }
              return e;
            });
          var g = o.documentElement,
            A = "svg" === g.nodeName.toLowerCase();
          b.addTest(
            "placeholder",
            "placeholder" in r("input") && "placeholder" in r("textarea"),
          ),
            b.addTest("inlinesvg", function() {
              var e = r("div");
              return (
                (e.innerHTML = "<svg/>"),
                "http://www.w3.org/2000/svg" ==
                ("undefined" != typeof SVGRect &&
                  e.firstChild &&
                  e.firstChild.namespaceURI)
              );
            });
          var _ = y._config.usePrefixes
            ? " -webkit- -moz- -o- -ms- ".split(" ")
            : ["", ""];
          (y._prefixes = _),
            b.addTest("csspositionsticky", function() {
              var e = "position:",
                t = "sticky",
                o = r("a").style;
              return (
                (o.cssText = e + _.join(t + ";" + e).slice(0, -e.length)),
                -1 !== o.position.indexOf(t)
              );
            });
          var C = "CSS" in t && "supports" in t.CSS,
            $ = "supportsCSS" in t;
          b.addTest("supports", C || $);
          var w = "Moz O ms Webkit",
            z = y._config.usePrefixes ? w.split(" ") : [];
          y._cssomPrefixes = z;
          var S = function(e) {
            var o,
              i = _.length,
              r = t.CSSRule;
            if (void 0 === r) return n;
            if (!e) return !1;
            if (
              (o =
                (e = e.replace(/^@/, "")).replace(/-/g, "_").toUpperCase() +
                "_RULE") in r
            )
              return "@" + e;
            for (var a = 0; i > a; a++) {
              var s = _[a];
              if (s.toUpperCase() + "_" + o in r)
                return "@-" + s.toLowerCase() + "-" + e;
            }
            return !1;
          };
          y.atRule = S;
          var q = y._config.usePrefixes ? w.toLowerCase().split(" ") : [];
          y._domPrefixes = q;
          var k = { elem: r("modernizr") };
          b._q.push(function() {
            delete k.elem;
          });
          var x = { style: k.elem.style };
          b._q.unshift(function() {
            delete x.style;
          }),
            (y.testAllProps = p),
            (y.testAllProps = m),
            (function() {
              b.addTest("csscolumns", function() {
                var e = !1,
                  t = m("columnCount");
                try {
                  (e = !!t) && (e = new Boolean(e));
                } catch (e) {
                }
                return e;
              });
              for (
                var e,
                  t,
                  o = [
                    "Width",
                    "Span",
                    "Fill",
                    "Gap",
                    "Rule",
                    "RuleColor",
                    "RuleStyle",
                    "RuleWidth",
                    "BreakBefore",
                    "BreakAfter",
                    "BreakInside",
                  ],
                  n = 0;
                n < o.length;
                n++
              )
                (e = o[n].toLowerCase()),
                  (t = m("column" + o[n])),
                ("breakbefore" === e ||
                  "breakafter" === e ||
                  "breakinside" == e) &&
                (t = t || m(o[n])),
                  b.addTest("csscolumns." + e, t);
            })(),
            b.addTest("flexbox", m("flexBasis", "1px", !0)),
            b.addTest("csstransforms", function() {
              return (
                -1 === navigator.userAgent.indexOf("Android 2.") &&
                m("transform", "scale(1)", !0)
              );
            }),
            b.addTest("csstransforms3d", function() {
              return !!m("perspective", "1px", !0);
            });
          var T = (y.prefixed = function(e, t, o) {
            return 0 === e.indexOf("@")
              ? S(e)
              : (-1 != e.indexOf("-") && (e = a(e)),
                t ? p(e, t, o) : p(e, "pfx"));
          });
          b.addTest("objectfit", !!T("objectFit"), { aliases: ["object-fit"] });
          var E = (y.testStyles = c);
          b.addTest("touchevents", function() {
            var e;
            if (
              "ontouchstart" in t ||
              (t.DocumentTouch && o instanceof DocumentTouch)
            )
              e = !0;
            else {
              var n = [
                "@media (",
                _.join("touch-enabled),("),
                "heartz",
                ")",
                "{#modernizr{top:9px;position:absolute}}",
              ].join("");
              E(n, function(t) {
                e = 9 === t.offsetTop;
              });
            }
            return e;
          }),
            (function() {
              var e, t, o, n, r, a;
              for (var s in h)
                if (h.hasOwnProperty(s)) {
                  if (
                    ((e = []),
                    (t = h[s]).name &&
                    (e.push(t.name.toLowerCase()),
                    t.options &&
                    t.options.aliases &&
                    t.options.aliases.length))
                  )
                    for (o = 0; o < t.options.aliases.length; o++)
                      e.push(t.options.aliases[o].toLowerCase());
                  for (
                    n = i(t.fn, "function") ? t.fn() : t.fn, r = 0;
                    r < e.length;
                    r++
                  )
                    1 === (a = e[r].split(".")).length
                      ? (b[a[0]] = n)
                      : (!b[a[0]] ||
                      b[a[0]] instanceof Boolean ||
                      (b[a[0]] = new Boolean(b[a[0]])),
                        (b[a[0]][a[1]] = n)),
                      v.push((n ? "" : "no-") + a.join("-"));
                }
            })(),
            (function(e) {
              var t = g.className,
                o = b._config.classPrefix || "";
              if ((A && (t = t.baseVal), b._config.enableJSClass)) {
                var n = new RegExp("(^|\\s)" + o + "no-js(\\s|$)");
                t = t.replace(n, "$1" + o + "js$2");
              }
              b._config.enableClasses &&
              ((t += " " + o + e.join(" " + o)),
                A ? (g.className.baseVal = t) : (g.className = t));
            })(v),
            delete y.addTest,
            delete y.addAsyncTest;
          for (var L = 0; L < b._q.length; L++) b._q[L]();
          t.Modernizr = b;
        })(window, document);
      },
      {},
    ],
    9: [
      function(e) {
        "use strict";
        e("./components/Lazysizes"),
          e("./components/Modernizr"),
          e("./components/DisableFormZoom"),
          e("./classes/MobileMenu"),
          e("./classes/ObjectFit"),
          e("./classes/General");
      },
      {
        "./classes/General": 3,
        "./classes/MobileMenu": 4,
        "./classes/ObjectFit": 5,
        "./components/DisableFormZoom": 6,
        "./components/Lazysizes": 7,
        "./components/Modernizr": 8,
      },
    ],
  },
  {},
  [9],
),
  $(".c-nav-mobile__list-item").on("click", function() {
    var e = $(this).find("ul.c-nav-mobile__list");
    $(e).slideToggle();
  });
const responsiveTables = document.querySelectorAll(".responsive-table");
for (const e of responsiveTables) {
  e.classList.remove("responsive-table");
  const t = document.createElement("div");
  t.classList.add("responsive-table"),
    (t.style.overflowX = "auto"),
    (t.innerHTML = e.outerHTML),
    e.replaceWith(t);
}
document
  .querySelector(".o-page-container")
  .addEventListener("click", function(e) {
    e.target.classList.value.includes("c-header") ||
    (document
        .querySelector(".c-nav-mobile")
        .classList.contains("c-nav-mobile--nav-open") &&
      (document
        .querySelector(".c-nav-mobile")
        .classList.toggle("c-nav-mobile--nav-open"),
        document
          .querySelector(".o-page-container")
          .classList.toggle("o-page-container--nav-open")));
  });

const consentEvt = (e) => {
  const acceptedCategories = e.detail || {};

  if (acceptedCategories?.performance) {
    const tracking = new Tracking();
    tracking.init();
  } else {
    Tracking.clear();
  }
};

window.addEventListener("cf_consent", consentEvt);
window.addEventListener("cf_consent_loaded", consentEvt);

const quoteFormEl = document.querySelector(".quote-form");
if (quoteFormEl) {
  const quoteForm = new CrownForm({
    el: quoteFormEl,

    url: "/wp-content/themes/beesleyfuels/ajax/QuoteForm.php",

    button: {
      submittingText: "Submitting...",
      defaultText: "Get My Quote",
    },

    success(response) {
      const fuel = encodeURIComponent(document.querySelector("#quote-fuel")?.value || "");

      window.dataLayer?.push({
        event: "formSubmit",
        formId: "quote-form",
        fuel: response.form_data.fuel,
        litres: response.form_data.litres,
        customer_type: response.form_data["customer-type"],
        out_of_area: "In Area",
      });

      window.location.href = `/thank-you/?fuel=${fuel}`;
    },

    error(response) {
      const { code = "N/A", data = "N/A" } = response.error;
      let out_of_area = false;

      let destination = null;

      if (code === "OUT_OF_AREA") {
        destination = "/thank-you-out-of-area/";
        out_of_area = true;
      }

      if (destination) {
        window.dataLayer?.push({
          event: "formSubmit",
          formId: "quote-form",
          fuel: response.form_data.fuel,
          litres: response.form_data.litres,
          customer_type: response.form_data["customer-type"],
          out_of_area: out_of_area ? "Out of Area" : "In Area",
        });

        window.location.href = destination;
      } else {
        this.addError(`An error occurred and we're not sure why. Please try again, or contact us with the following code/message:<br /><br />
  Code: ${code}<br />
  Message: ${JSON.stringify(data)}`);
      }

    },
  });

  if (quoteForm.el) {
    function updateLitresOptions(product) {
      let litresOpts;

      if (product === "Kerosene / Heating Oil") {
        litresOpts = [
          "500",
          "750",
          "1,000",
          "1,250",
          "1,500",
          "1,750",
          "2,000",
          "2,299",
          "2,300+",
        ];
      } else if (product === "Lubricants") {
        litresOpts = [
          "25",
          "205",
          "1,500-2,000",
          "2,001-2,500",
          "2,501-3,000",
          "3,001+",
        ];
      } else if (product === "AdBlue") {
        litresOpts = [
          "25",
          "205",
          "1,500-2,000",
          "2,001-2,500",
          "2,501-3,000",
          "3,001+",
        ];
      } else if (product === "Red Diesel") {
        litresOpts = [
          "500-999",
          "1,000-1,999",
          "2,000-2,300",
          "2,301-3,999",
          "4,000-5,999",
          "6,000-7,999",
          "8,000-9,999",
          "10,000-14,999",
          "15,000-19,999",
          "20,000-24,999",
          "25,000-35,999",
          "36,000+",
        ];
      } else {
        litresOpts = [
          "1,000-1,999",
          "2,000-2,300",
          "2,301-3,999",
          "4,000-5,999",
          "6,000-7,999",
          "8,000-9,999",
          "10,000-14,999",
          "15,000-19,999",
          "20,000-24,999",
          "25,000-35,999",
          "36,000+",
        ];
      }

      if (quoteForm.el.querySelector("#quote-litres")) {
        const litresSelect = quoteForm.el.querySelector("#quote-litres");

        let litresHtml = "<option value=\"\" disabled selected>Litres*</option>";

        litresOpts.forEach((el) => (litresHtml += `<option value="${el}">${el}</option>`));

        if (litresSelect) {
          litresSelect.innerHTML = litresHtml;
        }
      }
    }

    quoteForm.el
      .querySelector("#quote-fuel")
      ?.addEventListener("change", (e) => updateLitresOptions(e.target.value));

    // select default fuel option and set correct litres options
    if (defaultFuelOption) {
      const fuel = quoteForm.el.querySelector("#quote-fuel");
      if (fuel) {
        const fuelIndex = [...fuel.options].findIndex(
          (el) => el.value === defaultFuelOption,
        );

        if (fuelIndex) {
          fuel.selectedIndex = fuelIndex;
          updateLitresOptions(defaultFuelOption);
        }
      }
    }
  }
}

new CrownForm({
  el: document.querySelector(".services-form"),

  url: "/wp-content/themes/beesleyfuels/ajax/ServiceForm.php",

  button: {
    submittingText: "Submitting...",
    defaultText: "Get My Quote",
  },

  success(response) {
    const { service } = response.form_data;

    window.dataLayer?.push({
      event: "formSubmit",
      formId: "services-form",
      service,
    });

    window.location.href = "/thank-you/?service=" + encodeURIComponent(service);
  },
});

new CrownForm({
  el: document.querySelector(".free-lubricant-form"),

  url: "/wp-content/themes/beesleyfuels/ajax/LubricantHealthCheckForm.php",

  button: {
    submittingText: "Submitting...",
    defaultText: "Book Now",
  },

  success() {
    window.dataLayer?.push({
      event: "formSubmit",
      formId: "free-lubricant-form",
    });

    window.location.href = "/thank-you-lubricant-health-check/";
  },
});

new CrownForm({
  el: document.querySelector(".free-site-survey-form"),

  url: "/wp-content/themes/beesleyfuels/ajax/FreeSiteSurveyForm.php",

  button: {
    submittingText: "Submitting...",
    defaultText:"Book Site Survey",
  },

  success() {
    window.dataLayer?.push({
      event: "formSubmit",
      formId: "free-site-survey-form",
    });

    window.location.href = "/thank-you-site-survey/";
  },
});

const h1 = document.querySelector("h1");
if (h1) {
  (new IntersectionObserver(([h1]) => {
    if (h1.isIntersecting) {
      document.body.classList.remove("header--scrolled");
    } else {
      document.body.classList.add("header--scrolled");
    }
  })).observe(h1);
}

const getAndSetHeaderHeight = () => {
  const header = document.querySelector(".c-header");
  const headerHeight = header.getBoundingClientRect().height;

  document.documentElement.style.setProperty("--header-height", `${headerHeight}px`);
}

window.addEventListener('load', getAndSetHeaderHeight);
window.addEventListener('resize', getAndSetHeaderHeight);
